import bohoHarmonyApartment from '@/assets/img/users-cases/boho-harmony-apartment.webp';
import bohoHarmonyApartmentHow from '@/assets/img/users-cases/boho-harmony-apartment-how.webp';
import bohoHarmonyApartmentResult from '@/assets/img/users-cases/boho-harmony-apartment-result.webp';

export default {
  slug: 'boho-harmony-apartment',
  order: 16,
  title: '360 Boho Floor Plan',
  subtitle: 'Cozy apartment renderings with lifestyle visuals',
  tags: ['Apartmentfloorplans', 'InteriorDesign'],

  images: {
    hero: bohoHarmonyApartment,
    aboutTop: bohoHarmonyApartmentHow,
    aboutBottom: bohoHarmonyApartmentResult,
  },

  howText:
    'We put together 2D and 3D apartment floor plans and interior design solutions that reinforce the project’s style and support the overall marketing concept.',

  resultText:
    'The final visuals help marketing teams stand out in advertising campaigns and sales presentations.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
